export default __webpack_public_path__ + "static/media/oticas.com.7aa1f07f.svg";